import AiProjectAssistant from './src/main';

/* istanbul ignore next */
AiProjectAssistant.install = function(Vue) {
  Vue.component(AiProjectAssistant.name, AiProjectAssistant);
};

export default AiProjectAssistant;
